// 応募しない求人一覧
import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';
import { TrnShintyokuSelectRequest } from '@/types/request';
import { ref } from 'vue';
import { OrderApply, OrderInfo, OrderInfoResponse, ShintyokuReApplyResponse,  TrnShintyokuRefusalRequest, UpdateApplyPublicMultipleResponse, UpdateApplySearchResponse, UpdateResponse } from '@/types';

type LocationInfo = {
  orderIds: string[];
  locationNo: string;
};

export const getShintyoku = async (params: TrnShintyokuSelectRequest) => {
  const res = await axios.post(endpoint.getShintyoku, params);
  return res;
};

export const countCloseApplyProgress = async () => {
  const res = await axios.get(endpoint.countCloseApplyProgress);
  return res;
};

export const getLocation = async (params: LocationInfo) => {
  const res = await axios.post(endpoint.getLocation, params);
  return res;
};

export const getOrderInfo = async (orderId: number) => {
  const res = await axios.get(`${endpoint.getOrderInfo}/${orderId}`);
  return res;
};

export const getOrdersInfo = async (params: { orderIds: number[] }) => {
  const res = await axios.post(endpoint.getOrdersInfo, params);
  return res.data.detail as OrderInfo[];
};

export const getOrderInfoById = async (orderId: number) => {
  const res = await axios.get(`${endpoint.getOrderInfo}/${orderId}`);
  return res.data as OrderInfoResponse;
};

export const getOrderDetailById = async (params: {orderId: number}) => {
  const res = await axios.post(endpoint.getOrderDetail, params);
  return res.data as OrderInfoResponse;
};

export const getOrdersDetail = async (params: {orderIds: number[]}) => {
  const res = await axios.post(endpoint.getOrdersDetail, params);
  return res.data.detail as OrderInfo[];
};

export const getPrefName = async (prefId: number) => {
  const res = await axios.get(`${endpoint.getPrefName}/${prefId}`);
  return res;
};

export const getCityName = async (cityId: number) => {
  const res = await axios.get(`${endpoint.getCityName}/${cityId}`);
  return res;
};

export const setFavorite = async (params: { orderIds: number[]; pendingFlg: number }) => {
  const res = await axios.post(endpoint.setPendingFlg, params);
  return res;
};

export const writeLogtrnOperationLog = async (params: {orderId: number, clientId: number, operationId: number, videoUrl: string }) => {
  const res = await axios.post(endpoint.writelogtrnoperationlog, params);
  return res;
};

export const setRefusalShintyoku = async (params: TrnShintyokuRefusalRequest) => {
  let updateResponse: UpdateResponse = {} as UpdateResponse;
  try {
    const res = await axios.post<UpdateResponse>(endpoint.updateRefusalShintyoku, params);
    return (updateResponse = res.data);
  } catch (error) {
    return updateResponse;
  }
};

export const setApplyShintyoku = async (params: OrderApply[]) => {
  let updateResponse: UpdateResponse = {} as UpdateResponse;
  try {
    const res = await axios.post<UpdateResponse>(endpoint.updateApplyShintyoku, {ordersApply: params});
    return (updateResponse = res.data);
  } catch (error) {
    return updateResponse;
  }
};


export const setApplyPublicShintyoku = async (params: OrderApply[]) => {
  let updateResponse: UpdateApplyPublicMultipleResponse = {} as UpdateApplyPublicMultipleResponse;
  try {
    const res = await axios.post(endpoint.updateApplyPublicMultiShintyoku, {ordersApply: params});
    return (updateResponse = res.data);
  } catch (error) {
    return updateResponse;
  }
};

export const setReApplyShintyoku = async (params: OrderApply) => {
  try {
    const res = await axios.post(endpoint.updateReApplyShintyoku, params);
    return (res.data as ShintyokuReApplyResponse);
  } catch (error) {
    return {} as ShintyokuReApplyResponse;
  }
};


export const setApplyShintyokuFromSearch = async (params: OrderApply) => {
  const updateResponse = ref<UpdateApplySearchResponse | null>(null);
  const res = await axios.post<UpdateApplySearchResponse>(endpoint.updateApplyShintyokuFromSearch, params);
  return (updateResponse.value = res.data);
};

export const getCountApplyList = async () => {
  const res = await axios.post(endpoint.countApplyList, {});
  return res;
};

export const getCheckReApply = async (orderId: number) => {
  try{
    const res = await axios.post(endpoint.checkReApply, orderId);
    return (res.data as ShintyokuReApplyResponse);
  } catch (error) {
    return {} as ShintyokuReApplyResponse;
  }
};

export const getCheckApply = async (orderId: number) => {
  try{
    const res = await axios.post(endpoint.checkApply, orderId);
    return (res.data as ShintyokuReApplyResponse);
  } catch (error) {
    return {} as ShintyokuReApplyResponse;
  }
};
